import { gsap } from 'gsap/all'
import { breakpoint } from 'helpers'
import { debounce } from 'throttle-debounce'

export const productPage = (target) => {
  const el = {
    image: target.querySelector('.product-page__image'),
    whiteBox: target.querySelector('.product-page__box--white'),
  }

  const method = {
    init: () => {
      method.setImagePosition()
      window.addEventListener('resize', debounce(120, method.setImagePosition))
    },

    setImagePosition: () => {
      if (!el.image || !el.whiteBox) return

      gsap.set(el.image, {
        clearProps: window.innerWidth < breakpoint.tablet ? 'all' : '',
        marginTop: -el.whiteBox.offsetHeight,
      })
    },
  }

  method.init()
}
